

import { ReactComponent as Logo } from "@assets/logo/M_WHITE_LOGO_FULL.svg";

import './styles.scss'

import { Button, Text } from '@fragments'
import { IconMoon, IconSun, IconUser, IconLayoutSidebarLeftCollapseFilled, IconLayoutSidebarLeftExpandFilled } from "@tabler/icons-react";
import { useScreen } from "@hooks/useScreen";
import { useAuth } from "@contexts/AuthContext";
import { useSidebar } from '../SidebarContext';

export default function SidebarHeader() {
    const { resolvedAppearance, setAppearance } = useScreen();
    const { user } = useAuth()
    const { collapsed, toggleSidebar } = useSidebar()

    const username = user?.username?.split(" ")?.[0] || ''

    const toggleBtn = (
        <Button
            color={collapsed ? "inverse" : "overlay"}
            size="small"
            variant="rounded"
            icon={collapsed
                ? <IconLayoutSidebarLeftExpandFilled />
                : <IconLayoutSidebarLeftCollapseFilled />
            }
            onClick={toggleSidebar}
            tooltip={collapsed ? "Expandir sidebar" : "Colapsar sidebar"}
        />
    )

    const themeBtn = (
        <Button
            color="overlay"
            size="small"
            variant="rounded"
            icon={resolvedAppearance === 'dark' ? <IconMoon /> : <IconSun />}
            onClick={() => setAppearance(resolvedAppearance === 'dark' ? 'light' : 'dark')}
            tooltip="Mudar tema"
        />
    )

    return (
        <div className="cs-sidebar-header">
            <div className="cs-sidebar-header-top">
                <Logo className="header-logo" />

                <div className="cs-sidebar-header-actions">
                    {collapsed ? (
                        <>
                            {toggleBtn}
                            {themeBtn}
                        </>
                    ) : (
                        <>
                            {themeBtn}
                            {toggleBtn}
                        </>
                    )}
                </div>
            </div>

            <Text.h4
                contrast={8}
                left={<IconUser />}
                weight={400}
                className="cs-sidebar-header-greeting"
            >
                    Olá, {username}
            </Text.h4>
        </div>
    )
}
